import React, { useState } from "react";

import styled from "@emotion/styled";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";

import { onGetUserIdsOptions } from "../../stores/report";

import Icon from "../../assets/icons/gray_i.svg";

import {
  FieldContainer,
  CustomSelect,
  Option,
  Label,
} from "../../components/CustomFields";

const SEMISTER_NUM = 3;
const SEMISTER_YEAR = 3;

const taps = [
  {
    value: "individual",
    label: "ข้อมูลรายบุคคล",
  },
  {
    value: "collective",
    label: "มุมมองอื่นๆ",
  },
];

const weekOptions = new Array(16)
  .fill(0)
  .map((_, i) => ({ value: i + 1, label: i + 1 }));

const cumulativeOptions = [
  {
    value: true,
    label: "ผลถึงสัปดาห์ที่",
  },
  {
    value: false,
    label: "เฉพาะสัปดาห์ที่",
  },
];

const scopeOptions = [
  {
    value: "school",
    label: "โรงเรียน",
  },
  {
    value: "level",
    label: "ชั้นเรียน",
  },
  {
    value: "room",
    label: "ห้องเรียน",
  },
];

const ReportForm = ({ form, currentTap, setTap, DownloadBtn }) => {
  const dispatch = useDispatch();
  const {
    schoolInfo,
    studentIdOptions = [],
    matchList = [],
  } = useSelector((s) => s.report);

  const [scope, setScope] = useState((form.getFieldsValue(true) || {}).scope);

  const levelOptions = new Array(6)
    .fill(0)
    .map((_, i) => ({ value: i + 1, label: `ม.${i + 1}` }));
  const roomOptions = new Array(schoolInfo.roomUnit)
    .fill(0)
    .map((_, i) => ({ value: i + 1, label: i + 1 }));

  const searchUser = () => {
    form.setFieldsValue({ studentId: null });
    const values = form.getFieldsValue(true);
    const { room, level } = values;
    if (room && level) {
      dispatch(onGetUserIdsOptions({ room, level }));
    }
  };

  const onLevelChange = (level) => {
    searchUser();
  };

  const onRoomChange = (room) => {
    searchUser();
  };

  return (
    <Container>
      <Topic>ขอทราบผล</Topic>
      <DownloadBtn />
      <FieldContainer
        name="semister"
        label="ชื่อกิจกรรมในการแข่งขัน"
        marginBottom={0}
      >
        <CustomSelect placeholder="โปรดระบุ" allowClear width="440px">
          {matchList.map((opt) => (
            <Option value={opt.id}>{opt.name}</Option>
          ))}
        </CustomSelect>
      </FieldContainer>
      <Suggestion>
        <SuggestionIcon src={Icon} />
        <SuggestionLabel>
          เพื่อการดูผลที่สะดวกขึ้นแนะนำให้ดูบนคอมพิวเตอร์
        </SuggestionLabel>
      </Suggestion>
      <FieldContainer name="map" label="" marginBottom={0}>
        <Tap
          taps={taps}
          didChange={(newTap) => {
            form.setFieldsValue({ mode: newTap });
            setTap(newTap);
          }}
        />
      </FieldContainer>
      {currentTap === "individual" && (
        <RowFieldContainer>
          <FieldContainer name="level" label="ชั้น" marginBottom={0}>
            <CustomSelect
              placeholder="โปรดระบุ"
              allowClear
              width="141.33px"
              widthRs="109px"
              onChange={onLevelChange}
            >
              {levelOptions.map((opt) => (
                <Option value={opt.value}>{opt.label}</Option>
              ))}
            </CustomSelect>
          </FieldContainer>
          <FieldContainer name="room" label="ห้อง" marginBottom={0}>
            <CustomSelect
              placeholder="โปรดระบุ"
              allowClear
              width="141.33px"
              widthRs="109px"
              onChange={onRoomChange}
            >
              {roomOptions.map((opt) => (
                <Option value={opt.value}>{opt.label}</Option>
              ))}
            </CustomSelect>
          </FieldContainer>
          <FieldContainer
            name="studentId"
            label="ชื่อ (ชื่อเล่น)"
            marginBottom={0}
          >
            <CustomSelect
              placeholder="โปรดระบุ"
              allowClear
              width="141.33px"
              widthRs="109px"
            >
              {studentIdOptions.map((opt) => (
                <Option value={opt.value}>{opt.label}</Option>
              ))}
            </CustomSelect>
          </FieldContainer>
        </RowFieldContainer>
      )}
      {currentTap === "collective" && (
        <>
          <RowFieldContainer>
            <FieldContainer
              name="isCumulative"
              label="รูปแบบคะแนน"
              marginBottom={0}
            >
              <CustomSelect
                placeholder="โปรดระบุ"
                allowClear
                width="216px"
                widthRs="167.5px"
              >
                {cumulativeOptions.map((opt) => (
                  <Option value={opt.value}>{opt.label}</Option>
                ))}
              </CustomSelect>
            </FieldContainer>
            <FieldContainer name="week" label=" " marginBottom={0}>
              <CustomSelect
                placeholder="โปรดระบุ"
                allowClear
                width="216px"
                widthRs="167.5px"
              >
                {weekOptions.map((opt) => (
                  <Option value={opt.value}>{opt.label}</Option>
                ))}
              </CustomSelect>
            </FieldContainer>
          </RowFieldContainer>
          <FieldContainer name="scope" label="ดูในมุมมองของ" marginBottom={0}>
            <CustomSelect
              placeholder="โปรดระบุ"
              allowClear
              width="440px"
              onChange={setScope}
            >
              {scopeOptions.map((opt) => (
                <Option value={opt.value}>{opt.label}</Option>
              ))}
            </CustomSelect>
          </FieldContainer>
          {scope !== "school" && (
            <RowFieldContainer>
              {(scope === "level" || scope === "room") && (
                <FieldContainer name="level" label="ชั้น" marginBottom={0}>
                  <CustomSelect
                    placeholder="โปรดระบุ"
                    allowClear
                    width={scope !== "room" ? "440px" : "208px"}
                  >
                    {levelOptions.map((opt) => (
                      <Option value={opt.value}>{opt.label}</Option>
                    ))}
                  </CustomSelect>
                </FieldContainer>
              )}
              {scope === "room" && (
                <FieldContainer name="room" label="ห้อง" marginBottom={0}>
                  <CustomSelect placeholder="โปรดระบุ" allowClear width="208px">
                    {roomOptions.map((opt) => (
                      <Option value={opt.value}>{opt.label}</Option>
                    ))}
                  </CustomSelect>
                </FieldContainer>
              )}
            </RowFieldContainer>
          )}
        </>
      )}
    </Container>
  );
};

const Tap = ({ taps, value = "individual", onChange, didChange }) => {
  return (
    <TapContainer>
      {taps.map((t) => (
        <TapItem onClick={() => onChange(t.value) || didChange(t.value)}>
          <TapLabel active={value === t.value}>{t.label}</TapLabel>
          <TapLine active={value === t.value} />
        </TapItem>
      ))}
    </TapContainer>
  );
};

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  width: 440px;

  margin-top: 40px;

  ${responsive.mobile(css`
    width: 343px;
  `)}
`;

const Topic = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;

  letter-spacing: -0.02em;

  color: #058459;
  margin-bottom: 24px;
`;

const TapContainer = styled.div`
  display: flex;
  width: 100%;

  margin-bottom: 24px;
`;

const TapItem = styled.div`
  height: 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  flex: 1;

  cursor: pointer;
`;

const TapLabel = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: ${(props) => (props.active ? 700 : 400)};
  font-size: 18px;
  line-height: 26px;

  text-align: center;

  color: ${(props) => (props.active ? "#4b5768" : "#64748B")};
`;

const TapLine = styled.div`
  width: 100%;
  height: ${(props) => (props.active ? "4px" : "2px")};

  background: ${(props) => (props.active ? "#fc6b4b" : "#64748B")};
  border-radius: 8px;
`;

const RowFieldContainer = styled.div`
  display: flex;
`;

const Suggestion = styled.div`
  width: 343px;
  height: 32px;
  background: #e7eaee;
  border-radius: 30px;
  justify-content: center;
  align-items: center;

  display: none;

  margin-bottom: 28px;

  ${responsive.mobile(css`
    display: flex;
  `)}
`;
const SuggestionIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;

const SuggestionLabel = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;

  color: #a0abbb;
`;

export default ReportForm;
